import anonymizeDicomDataset from './anonymize/anonymizeDicomDataset';
import defaultScript from './anonymize/scripts/header-script.default';
import Instance from './types/Instance';

export default function anonymizeInstance(instance: Instance): Instance {
  const { dicomDataset } = instance.instanceData;

  if (!dicomDataset) {
    throw new Error(`No dicom dataset found for instance with imageId: ${instance.imageId}`);
  }

  const { dicomDataset: anonymizedDicomData, logs } = anonymizeDicomDataset(
    dicomDataset,
    defaultScript
  );
  instance.instanceData.anonymizedDicomData = anonymizedDicomData;
  instance.anonymizationLogs = logs;
  return instance;
}
